module.exports = __webpack_public_path__ + "06_short_black.f18fbf3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/06_short_black.png
// module id = xZTS
// module chunks = 0